export enum SocialMapPermissions {
  SocialMapContact = 'social-map-contact',
  SocialMapAvailability = 'social-map-availability',
}
